<style lang="scss" scoped>
.link {
  cursor: pointer;
}
</style>

<template>
  <td
    :class="{ 'table-danger': content !== null && content.deleted_at !== null }"
  >
    <router-link :to="link">
      <img height="45" width="45" class="rounded-circle mr-2 link" :src="src" />
      {{ content.name }}
    </router-link>
  </td>
</template>

<script lang="babel">
export default {
    props: ['content'],
    computed: {
      src () {
        return `${this.content.primary_image.url}?width=45&height=45`;
      },
      link () {
        if (this.content.type == 1) {
          return `/fake/kartei/${this.content.id}`;
        }
        return `/mitglieder/kartei/${this.content.id}`;
      }
    }
};
</script>
